import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import avtar5 from '../../assets/images/user/avatar-5.jpg'
import { getData } from '../Services/api';

// Backend already returns formatted time (e.g. "3:00 PM"), display directly
const formatTime = (timeStr) => {
  if (!timeStr) return '-';
  return timeStr;
};

const View = () => {
  const { id } = useParams();
  const [beatPlan, setBeatPlan] = useState(null);

  const fetchBeatPlanDetails = async () => {
    try {
      const res = await getData(`/beatPlan/details/${id}`);
      if (res.success) {
        setBeatPlan(res.data);
      }
    } catch (error) {
      console.log("Error fetching beat plan details", error);
    }
  };

  useEffect(() => {
    fetchBeatPlanDetails();
  }, [id]);

  if (!beatPlan) return <div className="pc-container"><p>Loading...</p></div>;

  return (
    <div className="pc-container">
      <div className="pc-content">
        <div className="page-header">
          <div className="page-block">
            <div className="row align-items-center">
              <div className="col-md-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">Home</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/beat/list">Beat Plan</Link>
                  </li>
                  <li className="breadcrumb-item" aria-current="page">
                    Beat Plan Details
                  </li>
                </ul>
              </div>
              <div className="col-md-12">
                <div className="page-header-title">
                  <h2 className="mb-0">Beat Plan Details</h2>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  {/* Beat Plan Info */}
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-label">Status</label>
                      <input type="text" className="form-control" value={beatPlan.status} disabled />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Date</label>
                      <input type="text" className="form-control" value={beatPlan.date} disabled />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Start - End Time</label>
                      <input type="text" className="form-control" value={`${formatTime(beatPlan.startTime)} - ${formatTime(beatPlan.endTime)}`} disabled />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Created At</label>
                      <input type="text" className="form-control" value={new Date(beatPlan.createdAt).toLocaleString()} disabled />
                    </div>
                  </div>

                  {/* User / Customer / Route Info */}
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-label">Assigned User</label>
                      <input type="text" className="form-control" value={beatPlan.User?.username || "-"} disabled />
                    </div>
                    <div className="form-group">
                      <label className="form-label">User Email</label>
                      <input type="text" className="form-control" value={beatPlan.User?.email || "-"} disabled />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Customer</label>
                      <input type="text" className="form-control" value={beatPlan.Customer?.name || "-"} disabled />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Customer Address</label>
                      <input type="text" className="form-control" value={beatPlan.Customer?.address || "-"} disabled />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Route</label>
                      <input type="text" className="form-control" value={beatPlan.Route?.route_name || "-"} disabled />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> 
    </div>
  );
};

export default View;  